import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    const input = this.inputTarget;
    const placeholders = input.dataset.placeholders.split(", ");
    let i = 0;
    let timer;

    function typingEffect() {
      let placeholder = placeholders[i].split("");
      var loopTyping = function () {
        if (placeholder.length > 0) {
          input.setAttribute(
            "placeholder",
            input.getAttribute("placeholder") + placeholder.shift()
          );
        } else {
          setTimeout(deletingEffect, 1000);
          return false;
        }
        timer = setTimeout(loopTyping, 100);
      };
      loopTyping();
    }

    function deletingEffect() {
      let placeholder = placeholders[i].split("");
      var loopDeleting = function () {
        if (placeholder.length > 0) {
          placeholder.pop();
          input.setAttribute("placeholder", placeholder.join(""));
        } else {
          if (placeholders.length > i + 1) {
            i++;
          } else {
            i = 0;
          }
          typingEffect();
          return false;
        }
        timer = setTimeout(loopDeleting, 50);
      };
      loopDeleting();
    }

    typingEffect();
  }
}
